import React, { memo } from "react";

import { useHusibuechContext } from "../../context/husibuechContext";
import { Grid } from "@mui/material";
import TypeBoxComponent from "./1_CardElements/TypeBoxComponent";
import NameBoxComponent from "./1_CardElements/NameBoxComponent";
// import ErrorBox from "../CardElements/ErrorBox";

function LineOne({
  type,
  onChangeType,
  assignmentName,
  onChangeAssignmentName,
  restricted,
}) {
  const { userCourses } = useHusibuechContext();
  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      spacing={1}
      sx={{ marginTop: "4px" }}
    >
      {/* Type Container */}
      <Grid xs={4}>
        {type && (
          <TypeBoxComponent
            restricted={restricted}
            type={type}
            userCourses={userCourses}
            change={onChangeType}
          />
        )}
      </Grid>

      {/* Assignment Name Container */}
      <Grid xs={7}>
        <NameBoxComponent
          restricted={false}
          assignmentName={assignmentName}
          change={onChangeAssignmentName}
        />
      </Grid>
    </Grid>
  );
}

export default memo(LineOne);
